import React, { useCallback, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import I18n from "i18n-js";
import { Button } from "@mex/mex-web-ui";
import "./index.less";
import XSvg from "./assets/x.svg";
import LeftMFCHomeImg from "./assets/left-mfc-home.svg";
import { directToURl, ADSUMP, isRoleCashier } from "../utils";
import { generateUTMParams } from './util';

const DISMISS_LS_KEY = "__DISMISSED_MFC_AT__";

const isSameDay = (date1, date2) => {
  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  );
};

const hasDismissedToday = () => {
  const dismissedAt = new Date(
    parseInt(window.localStorage.getItem(DISMISS_LS_KEY) || "0", 10)
  );
  const now = new Date();
  return isSameDay(dismissedAt, now);
};

const useOpenStatus = () => {
  const initialOpen = !isRoleCashier() && !hasDismissedToday();
  const [open, setOpen] = useState(initialOpen);

  return [open, setOpen];
};

export const MarketingBannerMFC = (props) => {
  const { className, onClick, onClose, onOpen, trackEvent, tab, subtab } = props;
  const [open, setOpen] = useOpenStatus();
  const message = 'Item discount is now available on Marketing Manager Pro.';
  const CTA_name = 'Try marketing Manager Pro';
  const eventType = 'promo';

  const _onClose = useCallback(() => {
    if (trackEvent) {
      trackEvent(
        "MARKETING_BANNER",
        "PRODUCT_UPSELL.BANNER_DISMISS",
        JSON.stringify({
          message,
          CTA_name,
          portal_tab: tab,
          portal_subtab: subtab,
          status: "Success",
          error_msg: null,
          type: eventType,
        })
      );
    }
    setOpen(false);
    window.localStorage.setItem(DISMISS_LS_KEY, new Date().getTime());
    if (onClose) {
      onClose();
    }
  }, [onClose, setOpen]);

  const _onClick = useCallback(() => {
    if (trackEvent) {
      trackEvent(
        "MARKETING_BANNER",
        "PRODUCT_UPSELL.BANNER_CLICK",
        JSON.stringify({
          message,
          CTA_name,
          portal_tab: tab,
          portal_subtab: subtab,
          status: "Success",
          error_msg: null,
          type: eventType,
        })
      );
    }
    if (onClick) {
      onClick();
    }
    const params = generateUTMParams("home", "MFC");
    directToURl(null, ADSUMP, params);
  }, [onClick, trackEvent]);

  const viewTracked = useRef(false);
  useEffect(() => {
    if (open && trackEvent && !viewTracked.current) {
      viewTracked.current = true;
      trackEvent(
        "MARKETING_BANNER",
        "PRODUCT_UPSELL.BANNER_VIEW",
        JSON.stringify({
          message,
          CTA_name,
          portal_tab: tab,
          portal_subtab: subtab,
          status: "Success",
          error_msg: null,
          type: eventType,
        }),
      );
    }
  }, [open, trackEvent]);

  useEffect(() => {
    if (open && onOpen) {
      onOpen();
    }
  }, [open, onOpen]);

  if (!open) return null;

  return (
    <div
      className={`troy-marketing-banner troy-marketing-banner--upsellMFCHome} ${className}`}
    >
      <img className="troy-marketing-banner__img" src={LeftMFCHomeImg} />

      <img
        className="troy-marketing-banner__close"
        src={XSvg}
        onClick={_onClose}
      />

      <div className="troy-marketing-banner__text-container">
        <p className="troy-marketing-banner__header">{I18n.t("apt_mm_title_item_discount_upsell_banner")}</p>
        <p className="troy-marketing-banner__description">{I18n.t("apt_mm_item_discount_upsell")}</p>
      </div>

      <Button
        variant="ghost"
        size="small"
        className={`troy-marketing-banner__cta troy-marketing-banner__cta--upsellMFCHome`}
        onClick={_onClick}
      >
        {I18n.t("apt_mm_acquisition_button_try_marketing_manager")}
      </Button>

      <svg
        className={`troy-marketing-banner__imgr troy-marketing-banner__imgr--upsellMFCHome`}
      >
        <circle cx={280} cy={200} r={89} fill="currentColor" />
      </svg>
    </div>
  );
};

MarketingBannerMFC.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  trackEvent: PropTypes.func,
  tab: PropTypes.string,
  subtab: PropTypes.string,
};

MarketingBannerMFC.defaultProps = {};
